import inverse from "./inverse";
import addSeconds from "./addSeconds";
import type { OwaDate } from "../schema";

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function inverse called at module scope is not allowed. This may cause unwanted side effects. */
const defaultExport: (value: OwaDate, amount: number) => OwaDate = inverse(addSeconds);
export default defaultExport;
